// import { userService } from '../../services/auth-api.service.js';
import { claimService } from '../../services/claim-api.service.js'
import router from '../../router.js'

const myclaimsInitialState = {
  claimsList: [],
  pagenation: null,
  selectedClaim: null,
  selectedGadget: null,
  loading: false
}

export const myclaimsModule = {
  namespaced: true,
  state: myclaimsInitialState,
  actions: {
    getClaimsList ({ dispatch, commit, state }, params) {
      commit('reset')
      if (state.claimsList.length == 0) {
        commit('setLoading', true)
        claimService.getAll(params)
          .then(
            response => {
              commit('setClaimsList', response.data)
              commit('setPagenation', response.pagenation)
              commit('setLoading', false)
            },
            error => {
              commit('setLoading', false)
            }
          )
      }
    },
    getClaim ({ dispatch, commit }, id) {
      commit('setLoading', true)
      claimService.getByWebReference(id)
        .then(
          response => {
            commit('setSelectedClaim', response.data)
            commit('setLoading', false)
          },
          error => {
            commit('setLoading', false)
          }
        )
    },
    getClaimForGadget ({ state, dispatch, commit }, id) {
      commit('setLoading', true)
      claimService.getByGadgetWebReference(id)
        .then(
          response => {
            commit('setSelectedClaim', response.data)
            let gadget = state.selectedClaim.gadgets.filter(g => g.id === id)[0]
            commit('setSelectedGadget', gadget)
            commit('setLoading', false)
          },
          error => {
            commit('setLoading', false)
          }
        )
    },
    setSelectedGadget ({ commit }, payload) {
      commit('setSelectedGadget', payload)
    },
    setSelectedGadgetFromSelectedClaim ({ state, commit }, payload) {
      let gadget = state.selectedClaim.gadgets.filter(g => g.id = payload)
      commit('setSelectedGadget', gadget)
    },
    reset ({ commit }) {
      commit('reset')
    },
    resetClaim ({ commit }) {
      commit('setSelectedClaim', {})
    },
    resetGadget ({ commit }) {
      commit('setSelectedGadget', null)
    }
  },
  mutations: {
    reset (state) {
      state.claimsList = []
      state.selectedClaim = null
      state.selectedGadget = null
      state.loading = false
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setClaimsList (state, payload) {
      state.claimsList = payload
    },
    setPagenation (state, payload) {
      state.pagenation = payload
    },
    setSelectedClaim (state, payload) {
      state.selectedClaim = payload
    },
    setSelectedGadget (state, payload) {
      state.selectedGadget = payload
    }
  }
}
